import { render } from "./blockTitle.vue?vue&type=template&id=657d2511&scoped=true"
import script from "./blockTitle.vue?vue&type=script&lang=js"
export * from "./blockTitle.vue?vue&type=script&lang=js"

import "./blockTitle.vue?vue&type=style&index=0&id=657d2511&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657d2511"]])

export default __exports__